// extracted by mini-css-extract-plugin
export default {"wrapper":"rC6akQ","container":"Jywbth","desktopButton":"cB1zGQ","mobileButton":"vEeeab","image":"lxqxEf","subtitle":"AWVXtf","content":"Ff2v9n"};